import { render, staticRenderFns } from "./AskAIButton.vue?vue&type=template&id=34c18f14&scoped=true&"
import script from "./AskAIButton.vue?vue&type=script&lang=js&"
export * from "./AskAIButton.vue?vue&type=script&lang=js&"
import style0 from "./AskAIButton.vue?vue&type=style&index=0&id=34c18f14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c18f14",
  null
  
)

export default component.exports